import React, { useRef, useEffect } from "react";
import { trackCustom } from "../../services/analytics";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import { GlobalStore } from "../../stores/global";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const DownloadApp = ({ content }) => {
  const downloadLink = useAppDownloadLink();
  const history = useHistory();
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);

  const handleButtonClick = (code, page) => {
    trackCustom("CompleteRegistration", code, page);
  };

  const subTitleRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (subTitleRef.current) {
        Array.from(subTitleRef.current.querySelectorAll("a")).forEach(ele => {
          if (ele.isAddCustomClick) {
            return;
          }
          ele.isAddCustomClick = true;
          ele.addEventListener("click", e => {
            e.preventDefault();
            handleButtonClick(countryCode);
            history.push(ele.getAttribute("href"));
          });
        });
      }
    }, 100);
  });

  return (
    <div className="downloadApp">
      <h3 className="title">{content.title}</h3>
      {!content.description ? (
        <p className="subtitle">
          Download the app on the AppStore or Play Store and book a
          <Link to={`/${countryCode.toLowerCase()}/telemedicine`} onClick={e => handleButtonClick(countryCode)}>
            <strong> Video call </strong>
          </Link>
          today.
        </p>
      ) : (
        <p
          className="subtitle"
          ref={subTitleRef}
          dangerouslySetInnerHTML={{ __html: markdown.render(content.description) }}
        />
      )}
      <a className="secondary sm" href={downloadLink}>
        {content.linkText}
      </a>
    </div>
  );
};

export default DownloadApp;
